import AppointmentDetails from './AppointmentDetails';

export default AppointmentDetails;
